import React from 'react';
import { differentiators, processStages, filmBrands, vehicleBrands } from '../mock';

export default function ProcessSection() {
  return (
    <section id="about" className="py-12 lg:py-24">
      <div className="section-pad max-w-[1440px] mx-auto">
        {/* Differentiators */}
        <div className="flex items-center justify-between mb-8 sm:mb-12">
          <span className="eyebrow"><span className="dot" /> Installation Standard</span>
          <span className="hidden sm:inline text-[0.62rem] font-mono tracking-widest text-[#8a8578]">04 DIFFERENTIATORS</span>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14 lg:mb-28">
          {differentiators.map((d) => (
            <div key={d.n} className="group">
              <div className="flex items-center justify-between mb-5">
                <span className="font-display text-5xl font-extrabold text-[#e8e3d7] group-hover:text-[#ff5a1f] transition-colors duration-500">{d.n}</span>
                <span className="text-[0.58rem] font-semibold tracking-widest text-[#8a8578]">{d.kicker}</span>
              </div>
              <div className="h-px w-full bg-black/10 mb-5 relative overflow-hidden">
                <span className="absolute inset-y-0 left-0 w-0 group-hover:w-full bg-[#ff5a1f] transition-all duration-700" />
              </div>
              <h3 className="font-display text-lg font-bold text-[#16150f] mb-3">{d.title}</h3>
              <p className="text-sm text-[#5a5548] leading-relaxed">{d.text}</p>
            </div>
          ))}
        </div>

        {/* Process workflow */}
        <div className="flex items-center justify-between mb-6 sm:mb-8">
          <span className="eyebrow"><span className="dot" /> Precision Workflow</span>
          <span className="hidden sm:inline text-[0.62rem] font-mono tracking-widest text-[#8a8578]">VINYLED / BENGALURU</span>
        </div>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="relative">
            {processStages.map((p) => (
              <div key={p.n} className="relative pl-16 pb-10 border-l border-black/12 last:border-l-transparent last:pb-0">
                <span className="absolute -left-[1.35rem] top-0 w-11 h-11 rounded-full bg-white border-2 border-[#ff5a1f] flex items-center justify-center font-display text-sm font-bold text-[#ff5a1f]">{p.n}</span>
                <p className="text-[0.62rem] font-semibold tracking-widest text-[#ff5a1f] mb-2">{p.stage}</p>
                <h3 className="font-display text-xl font-bold text-[#16150f] mb-2">{p.title}</h3>
                <p className="text-sm text-[#5a5548] leading-relaxed max-w-md">{p.text}</p>
                <p className="text-[0.68rem] font-mono text-[#a39d8e] mt-3">{p.meta}</p>
              </div>
            ))}
          </div>
          <div className="relative rounded-[1.4rem] overflow-hidden card-elevated h-[280px] sm:min-h-[440px] lg:sticky lg:top-28">
            <img src="https://res.cloudinary.com/dpexqacfj/image/upload/v1786961469/vinyled_working_process_ab2jjl.webp" alt="Installation process" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <span className="absolute top-5 right-5 inline-flex items-center gap-2 text-[0.6rem] font-semibold tracking-widest text-[#16150f] bg-white/90 backdrop-blur px-3 py-1.5 rounded-full"><span className="w-1.5 h-1.5 rounded-full bg-[#ff5a1f] animate-pulse-dot" /> READY</span>
            <div className="absolute bottom-6 left-6">
              <p className="font-display text-sm font-bold tracking-widest text-white">INSTALLATION</p>
              <p className="text-xs text-white/70 mt-1">Prepared · Applied · Inspected</p>
            </div>
          </div>
        </div>

        {/* Brands */}
        <div className="mt-14 lg:mt-28 grid lg:grid-cols-2 gap-10 lg:gap-14">
          <div>
            <div className="flex items-baseline gap-3 mb-6">
              <span className="font-display text-sm font-bold text-[#ff5a1f]">01</span>
              <h3 className="font-display text-lg font-bold text-[#16150f]">Protection Films</h3>
              <span className="text-xs text-[#8a8578]">— materials we work with</span>
            </div>
            <div className="overflow-hidden border-y border-black/8 py-5">
              <div className="flex animate-marquee-left w-max">
                {[...filmBrands, ...filmBrands, ...filmBrands].map((b, i) => (
                  <span key={i} className="font-display text-xl font-bold text-[#c9c3b5] px-7 whitespace-nowrap">{b}</span>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="flex items-baseline gap-3 mb-6">
              <span className="font-display text-sm font-bold text-[#ff5a1f]">02</span>
              <h3 className="font-display text-lg font-bold text-[#16150f]">Vehicle Brands</h3>
              <span className="text-xs text-[#8a8578]">— vehicles we protect &amp; transform</span>
            </div>
            <div className="overflow-hidden border-y border-black/8 py-5">
              <div className="flex animate-marquee-right w-max">
                {[...vehicleBrands, ...vehicleBrands].map((b, i) => (
                  <span key={i} className="font-display text-xl font-bold text-[#c9c3b5] px-7 whitespace-nowrap">{b}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
